// /pages/carrossier/FormulaireB/hooks/useFormSubmit.js
import { 
    getFirestore, 
    doc, 
    updateDoc, 
    getDoc, 
    setDoc 
  } from "firebase/firestore";
  import { app } from "../../../../firebaseConfig";
  import { cleanObjectForFirebase } from "../utils/firebaseUtils";
  
  export const useFormSubmit = ({ 
    productId, 
    orderId, 
    produit, 
    index, 
    formData, 
    onComplete, 
    setLoading 
  }) => {
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
  
      try {
        if (!orderId) {
          throw new Error("OrderId manquant - impossible de sauvegarder");
        }
  
        // Sécuriser les valeurs
        const safeProductId = productId || `product_${index || 0}_${Date.now()}`;
        const safeIndex = index !== undefined ? index : 0;
        const safeProduitName = produit?.name || "Produit HUSKY";
  
        console.log("🔍 Sauvegarde TypeB avec:", { 
          orderId, 
          safeProductId, 
          safeIndex, 
          originalProductId: productId,
          safeProduitName 
        });
  
        const db = getFirestore(app);
        
        // 1. Mise à jour du produit dans le dossier
        const dossierRef = doc(db, "dossiers", orderId);
        const dossierSnap = await getDoc(dossierRef);
        
        if (!dossierSnap.exists()) {
          throw new Error("Dossier non trouvé");
        }
  
        const dossierData = dossierSnap.data();
        const updatedProducts = [...(dossierData.produits || [])];
        
        // Marquer ce produit comme rempli
        if (updatedProducts[safeIndex]) {
          updatedProducts[safeIndex] = {
            ...updatedProducts[safeIndex],
            id: updatedProducts[safeIndex].id || safeProductId,
            filled: true,
            formulaireData: formData,
            formulaireType: "TypeB_HUSKY_CleverSafe",
            updatedAt: new Date().toISOString()
          };
        } else {
          updatedProducts[safeIndex] = {
            id: safeProductId,
            name: safeProduitName,
            filled: true,
            formulaireData: formData,
            formulaireType: "TypeB_HUSKY_CleverSafe",
            createdAt: new Date().toISOString()
          };
        }
  
        // Générer l'ID de déclaration
        let declarationId;
        if (productId && productId !== 'default' && productId !== null) {
          declarationId = `${productId}_unit_1`;
        } else {
          const baseName = safeProduitName.toLowerCase().replace(/[^a-z0-9]/g, '');
          declarationId = `${baseName}_${safeIndex}_unit_1`;
        }
        
        console.log("🔑 ID de déclaration TypeB généré:", declarationId);
        
        // Préparer les données de base
        const baseUpdateData = {
          produits: updatedProducts,
          lastModified: new Date().toISOString(),
          
          // Flags principaux
          [`${declarationId}_filled`]: true,
          [`${declarationId}_montage_complete`]: true,
          [`${declarationId}_status`]: "controle_montage_complete",
          [`produit_${safeIndex}_complete`]: true,
        };
  
        // Ajouter les flags productId si nécessaire
        if (productId && productId !== 'default' && productId !== null) {
          baseUpdateData[`${productId}_filled`] = true;
          baseUpdateData[`${productId}_montage_complete`] = true;
          baseUpdateData[`${productId}_unit_1_filled`] = true;
          baseUpdateData[`${productId}_unit_1_montage_complete`] = true;
          baseUpdateData[`${productId}_status`] = "controle_montage_complete";
        }
  
        // Structure formulaire
        const formulaireData = {
          type: "TypeB_HUSKY_CleverSafe",
          produitName: safeProduitName,
          formData: formData,
          completedAt: new Date().toISOString(),
          productIndex: safeIndex,
          declarationId: declarationId,
        };
  
        if (productId && productId !== 'default' && productId !== null) {
          formulaireData.productId = productId;
        }
  
        baseUpdateData[`formulaire_${safeProductId}`] = formulaireData;
  
        // Nettoyer et sauvegarder
        const updateData = cleanObjectForFirebase(baseUpdateData);
  
        console.log("🔥 FLAGS CRÉÉS POUR TypeB:", Object.keys(updateData).filter(key => 
          key.includes('filled') || key.includes('complete')
        ));
        
        await updateDoc(dossierRef, updateData);
        console.log("✅ Dossier TypeB mis à jour avec succès");
  
        // 2. Vérification post-sauvegarde
        const verificationSnap = await getDoc(dossierRef);
        const verificationData = verificationSnap.data();
        
        console.log("🔍 VÉRIFICATION POST-SAUVEGARDE TypeB:");
        console.log(`  - ${declarationId}_filled: ${verificationData[`${declarationId}_filled`]}`);
        console.log(`  - ${declarationId}_montage_complete: ${verificationData[`${declarationId}_montage_complete`]}`);
  
        // 3. Sauvegarde dans collection formulaires
        try {
          const formulaireDocId = `${orderId}_${safeProductId}`;
          const formulaireRef = doc(db, "formulaires", formulaireDocId);
          
          const formulaireCompleteData = cleanObjectForFirebase({
            orderId: orderId,
            productId: safeProductId,
            productIndex: safeIndex,
            type: "TypeB_HUSKY_CleverSafe",
            produitName: safeProduitName,
            formData: formData,
            createdAt: new Date().toISOString(),
            declarationId: declarationId,
            createdBy: "carrossier",
            originalProductId: productId && productId !== 'default' ? productId : null
          });
          
          await setDoc(formulaireRef, formulaireCompleteData);
          console.log("✅ Formulaire TypeB sauvegardé");
        } catch (formulaireError) {
          console.warn("⚠️ Erreur formulaire TypeB:", formulaireError);
        }
  
        alert(`✅ Contrôle montage et mise en service HUSKY CLEVER SAFE sauvegardé avec succès !
  
  🔑 ID déclaration: ${declarationId}
  📊 ProductId: ${productId || 'généré automatiquement'}
  🛡️ Type: HUSKY CLEVER SAFE
  
  Le statut devrait maintenant apparaître dans le dashboard carrossier.`);
        
        if (onComplete) onComplete();
  
      } catch (error) {
        console.error("❌ Erreur lors de la sauvegarde TypeB:", error);
        
        let errorMessage = "Erreur lors de la sauvegarde: ";
        
        if (error.code === 'invalid-argument') {
          errorMessage += "Données invalides.";
        } else if (error.code === 'permission-denied') {
          errorMessage += "Permissions insuffisantes.";
        } else {
          errorMessage += error.message;
        }
        
        alert(`❌ ${errorMessage}`);
      } finally {
        setLoading(false);
      }
    };
  
    return { handleSubmit };
  };